<template>
  <!--会员规则页面-->
  <tk-container :status="status" @refresh="getInit">
    <!--头部-->
    <my-header slot="header">会员规则</my-header>
    <!--内容-->
    <card v-if="memberRule" :height="500" :width="100">
      <div v-html="memberRule"></div>
    </card>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      memberRule: null // 联系我们内容
    }
  },
  computed: {},
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    async getInit () {
      try {
        this.setStatusBar('dark')
        let res = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/memberRule').catch(e => {
          return { data: null }
        })
        if (res.data) { this.memberRule = res.data } else { this.memberRule = null }
        if (!this.memberRule) {
          this.status = 'empty'
          return
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
